import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './theme';
import DashboardLayout from './components/Layout/DashboardLayout';
import Dashboard from './pages/DashboardHome';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import SchoolSignupPage from './pages/auth/SchoolSignupPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import StudentsPage from './pages/StudentsPage';
import InvoicesPage from './pages/InvoicesPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import PaymentsPage from './pages/PaymentsPage';
import AccountsPage from './pages/AccountsPage';
import ReportsPage from './pages/ReportsPage';
import ParentFinancePage from './pages/ParentFinancePage';
import ParentPortalPage from './pages/ParentPortalPage';
import StudentStatementPage from './pages/StudentStatementPage';
import FeeStructuresPage from './pages/FeeStructuresPage';
import CreateFeeStructurePage from './pages/CreateFeeStructurePage';
import RunBillingPage from './pages/RunBillingPage';
import SettingsPage from './pages/SettingsPage';
import GeneralLedgerPage from './pages/GeneralLedgerPage';
import ReceiptDetailPage from './pages/ReceiptDetailPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AuditLogsPage from './pages/AuditLogsPage';
import EventsPage from './pages/EventsPage';
import GroupsPage from './pages/GroupsPage';
import ClassroomDetailPage from './pages/ClassroomDetailPage';
import RolePermissionsPage from './pages/RolePermissionsPage';
import InventoryPage from './pages/InventoryPage';
import PosPage from './pages/PosPage';
import SuppliersPage from './pages/SuppliersPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import CreatePurchaseOrderPage from './pages/CreatePurchaseOrderPage';
import PurchaseOrderDetailPage from './pages/PurchaseOrderDetailPage';
import ReceptionistDashboard from './pages/ReceptionistDashboard';
import ChatPage from './pages/ChatPage';

// New SaaS Pages
import ExpensesPage from './pages/ExpensesPage';
import HRPage from './pages/HRPage';
import PayrollPage from './pages/PayrollPage';
import BudgetPage from './pages/BudgetPage';
import SupplierPaymentsPage from './pages/SupplierPaymentsPage';
import SaaSAdminDashboard from './pages/SaaSAdminDashboard';
import AcademicsDashboardPage from './pages/AcademicsDashboardPage';
import SubjectsPage from './pages/SubjectsPage';
import GradesPage from './pages/GradesPage';
import ExamsPage from './pages/ExamsPage';
import TimetablePage from './pages/TimetablePage';
import AttendancePage from './pages/AttendancePage';
import PromotionWizardPage from './pages/PromotionWizardPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/signup" element={<SchoolSignupPage />} />
          <Route path="/school-signup" element={<SchoolSignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="students" element={<StudentsPage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="invoices/:id" element={<InvoiceDetailPage />} />
            <Route path="payments" element={<PaymentsPage />} />
            <Route path="receipts/:id" element={<ReceiptDetailPage />} />
            
            {/* SaaS & Core Accounting Routes */}
            <Route path="accounts" element={<AccountsPage />} />
            <Route path="ledger" element={<GeneralLedgerPage />} />
            <Route path="expenses" element={<ExpensesPage />} />
            <Route path="hr" element={<HRPage />} />
            <Route path="payroll" element={<PayrollPage />} />
            <Route path="budgets" element={<BudgetPage />} />
            <Route path="supplier-payments" element={<SupplierPaymentsPage />} />
            
            {/* Academic & SaaS Admin Modules */}
            <Route path="academics" element={<AcademicsDashboardPage />} />
            <Route path="subjects" element={<SubjectsPage />} />
            <Route path="grades" element={<GradesPage />} />
            <Route path="exams" element={<ExamsPage />} />
            <Route path="timetable" element={<TimetablePage />} />
            <Route path="attendance" element={<AttendancePage />} />
            <Route path="promotion-wizard" element={<PromotionWizardPage />} />
            
            <Route path="saas-admin" element={<SaaSAdminDashboard />} />

            <Route path="reports" element={<ReportsPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="parent-finance" element={<ParentFinancePage />} />
            <Route path="parent-portal" element={<ParentPortalPage />} />
            <Route path="parent-portal/statement/:studentId" element={<StudentStatementPage />} />
            <Route path="fees" element={<FeeStructuresPage />} />
            <Route path="fees/create" element={<CreateFeeStructurePage />} />
            <Route path="fees/billing" element={<RunBillingPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="audit" element={<AuditLogsPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="permissions" element={<RolePermissionsPage />} />
            <Route path="groups" element={<GroupsPage />} />
            <Route path="groups/:id" element={<ClassroomDetailPage />} />
            <Route path="inventory" element={<InventoryPage />} />
            <Route path="suppliers" element={<SuppliersPage />} />
            <Route path="purchases" element={<PurchaseOrdersPage />} />
            <Route path="purchases/create" element={<CreatePurchaseOrderPage />} />
            <Route path="purchases/:id" element={<PurchaseOrderDetailPage />} />
            <Route path="pos" element={<PosPage />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="receptionist" element={<ReceptionistDashboard />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
